import { Panel } from "components/Panel/Panel";
import { ActivePickems } from "components/Pickem/PickemOptions/ActivePickems";
import { UpcomingPickems } from "components/Pickem/PickemOptions/UpcomingPickems";
import { cancelGroupRequest, joinGroup } from "firebase-config";
import { pickemPath } from "pages/PageConfigs";
import { GroupData } from "pages/PickemGroup/PickemGroupPage";
import { ColumnContainer, GrowColumn } from "pages/styles";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CenterFlexColumn } from "styles/layout";
import { EmptyGrowPanelText, ErrorText } from "styles/text";

import { InProgressSpinner } from "../CreateGroup/styles";
import { JoinGroupButton } from "../JoinGroup/styles";

interface Props {
  groupData: GroupData;
  groupId: string;
}
export const GroupOverview = ({ groupData, groupId }: Props) => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [controlsDisabled, setControlsDisabled] = useState<boolean>(false);

  const onClickJoinGroup = async () => {
    setControlsDisabled(true);
    setErrorMessage("");
    await new Promise((r) => setTimeout(r, 2000));
    joinGroup({ groupId: groupId })
      .then(() => {
        navigate(pickemPath);
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => {
        setControlsDisabled(false);
      });
  };

  const onClickCancelRequest = async () => {
    setControlsDisabled(true);
    setErrorMessage("");
    await new Promise((r) => setTimeout(r, 2000));
    cancelGroupRequest({ groupId: groupId })
      .then(() => {
        navigate(pickemPath);
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => {
        setControlsDisabled(false);
      });
  };

  if (!groupData.group) {
    return (
      <GrowColumn>
        <Panel>
          {getContentFromUserStatus(
            groupData.userStatus,
            onClickJoinGroup,
            onClickCancelRequest,
            errorMessage,
            controlsDisabled
          )}
        </Panel>
      </GrowColumn>
    );
  }
  return (
    <ColumnContainer>
      <GrowColumn>
        <Panel header="Active Pick'ems">
          <ActivePickems />
        </Panel>
        <Panel header="Upcoming Pick'ems">
          <UpcomingPickems />
        </Panel>
      </GrowColumn>
    </ColumnContainer>
  );
};

const getContentFromUserStatus = (
  userStatus: string,
  onClickJoinGroup: () => Promise<void>,
  onClickCancelRequest: () => Promise<void>,
  errorMessage: string,
  controlsDisabled: boolean
) => {
  switch (userStatus) {
    case "Unauthenticated":
      return (
        <EmptyGrowPanelText>
          You must be logged in to take part in a group
        </EmptyGrowPanelText>
      );
    case "Banned":
      return (
        <EmptyGrowPanelText>
          You have been banned from this group
        </EmptyGrowPanelText>
      );
    case "Request":
      return (
        // todo - dupe code
        <CenterFlexColumn style={{ marginBottom: "10px" }}>
          <EmptyGrowPanelText>
            You have an open request to join this group
          </EmptyGrowPanelText>
          <JoinGroupButton
            onClick={onClickCancelRequest}
            disabled={controlsDisabled}
          >
            {controlsDisabled ? <InProgressSpinner /> : "Cancel Request"}
          </JoinGroupButton>

          <ErrorText>{errorMessage}</ErrorText>
        </CenterFlexColumn>
      );
    case "Non-member":
      return (
        // todo - dupe code with PickemJoinGroup
        <CenterFlexColumn style={{ marginBottom: "10px" }}>
          <EmptyGrowPanelText>
            You are not a member of this group
          </EmptyGrowPanelText>
          <JoinGroupButton
            onClick={onClickJoinGroup}
            disabled={controlsDisabled}
          >
            {controlsDisabled ? <InProgressSpinner /> : "Join Group"}
          </JoinGroupButton>

          <ErrorText>{errorMessage}</ErrorText>
        </CenterFlexColumn>
      );
    default:
      return (
        <ErrorText>
          Unknown error, you are a member of this group, try refreshing
        </ErrorText>
      );
  }
};
